import './Login.css';
import { useNavigate } from "react-router-dom";
import React, { useState } from 'react';

function Login_page() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = () => {
    const correctUsername = 'admin';
    const correctPassword = '1234';

    if (username === correctUsername && password === correctPassword) {
      setError('');
      navigate('/registered');
    } else {
      setError('Invalid username or password!');
    }
  };

  return (
    <div className="App">
        <div className='header'>
            <div className='login_input'>
              <form onSubmit={(e) => {e.preventDefault(); handleLogin();}}>
                <input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Username"
                  className="input_box_username"
                  style={{ marginTop: '13vh' }}
                />
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  className="input_box_password"
                  style={{ marginTop: '3vh' }}
                />
                <div className='backsign'>
                  <button className="ok" type="submit" style={{ cursor: "pointer" }}>
                    Sign in
                  </button>
                  <button className='back' onClick={() => navigate("/")} style={{ cursor: "pointer"}}>
                    back
                  </button>
                </div>
              </form>
            </div>
            <div className='login_text'>
              Login
            </div>
            {error && (
              <div  className='error_text'>
                {error}
              </div>
            )}
        </div>
    </div>
  );
}

export default Login_page;